import { createContext, useContext, useState } from "react";

const ThemeContext = createContext()

const ThemeProvider = ({children})=>{
    const [theme, setTheme] = useState("dark")

    return <ThemeContext.Provider value={{theme, setTheme}}>{children}</ThemeContext.Provider>
}

const useTheme = ()=> useContext(ThemeContext)

export {ThemeProvider, useTheme}